import { memo, FC } from 'react'
import { useAppSelector } from 'states/hooks'
import { MinutesDisplayMode } from 'enums/app'
import { EventDetailMeetingMinutesPanelMeetingMinutes } from './components/eventDetailMeetingMinutesPanelMeetingMinutes/eventDetailMeetingMinutesPanelMeetingMinutes'
import { EventDetailMeetingMinutesPanelTranscriptionList } from './components/eventDetailMeetingMinutesPanelTranscriptionList/eventDetailMeetingMinutesPanelTranscriptionList'
import { useParams } from 'react-router-dom'
import { GetMeetingMinutesRequest } from '@crew/apis/project/models/getMeetingMinutes/request'
import { useGetMeetingMinutesQuery } from '@crew/apis/project/projectApis'
import { skipToken } from '@reduxjs/toolkit/query'
import { useEventDetailMeetingMinutesContext } from '../eventDetailMeetingMinutes'
import { MeetingMinutesGenerationState } from '@crew/enums/domain'

export type FormValues = {
  meetingMinutes: string | null
}

export const EventDetailMeetingMinutesPanel: FC = memo(() => {
  const { eventId } = useParams()

  // この処理が流れる際、eventIdが存在しない場合は正しく描画できないはずなのでエラーを投げる
  // （以降の処理の型制約上もこちらの方が都合が良いはず）
  if (!eventId) {
    throw new Error('eventId is undefined')
  }

  // 議事録の表示形式
  const selectedDisplayType = useAppSelector(
    (state) => state.eventDetailPage.selectedMinutesDisplayMode
  )

  const { setGeneratingMinutes } = useEventDetailMeetingMinutesContext()

  // 議事録情報を取得
  const useGetMeetingMinutesParam: GetMeetingMinutesRequest = {
    eventId: eventId,
  }
  const { data: getMeetingMinutesResult } = useGetMeetingMinutesQuery(
    useGetMeetingMinutesParam ?? skipToken
  )
  // 議事録タブ表示時点のAI生成中かどうかを保持する
  setGeneratingMinutes(
    getMeetingMinutesResult?.event?.meetingMinutesGenerationState ===
      MeetingMinutesGenerationState.Processing
  )

  return (
    <div className="h-full flex flex-col gap-3">
      {/* 議事録 */}
      {selectedDisplayType === MinutesDisplayMode.Minutes.value && (
        <EventDetailMeetingMinutesPanelMeetingMinutes />
      )}

      {/* 文字起こし一覧 */}
      {selectedDisplayType === MinutesDisplayMode.Transcription.value && (
        <EventDetailMeetingMinutesPanelTranscriptionList />
      )}
    </div>
  )
})
